// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const {
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    CONTRIBUTION_PERIOD_MONTHLY,
    MINIMUM_PERIODIC_CONTRIBUTION,
} = require('constants/RAConstants/index');

const initialState = Immutable.fromJS({
    error: null,
    errorFlags: false,
    initialContributionAmount: 0,
    investProfileValue: '',
    investSliderValue: 1,
    isFetchedInvestProfile: false,
    isFetching: false,
    isFetchingInvestProfile: false,
    isSavingSimulation: false,
    maxInvestProfileValue: 1,
    newProfile: null,
    periodicity: CONTRIBUTION_PERIOD_MONTHLY,
    recurringAmountError: false,
    hasRecurringContribution: false,
    recurringContributionAmount: 0,
    recurringContributionDay: '',
    showDetails: true,
});

const RAManagementPlan = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_REQUEST:
            return state.merge({
                isFetchingInvestProfile: true,
                error: null,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_GET_INVESTMENT_PROFILE_SUCCESS:
            const { initialContribution, maxTypeOfProduct, selectedPortfolio, hasRecurringTransfer, id } =
                action.payload.data;
            let recurringTransfer = {};
            let newState = state;

            if (hasRecurringTransfer) {
                const { amount, cutDay, frequencyCode } = action.payload.data.recurringTransfer;

                newState = state.merge({
                    periodicity: frequencyCode,
                    recurringContributionAmount: amount,
                    recurringContributionDay: cutDay,
                });
            }

            return newState.merge({
                hasRecurringContribution: hasRecurringTransfer,
                initialContributionAmount: initialContribution,
                investProfileValue: selectedPortfolio || '',
                investSliderValue: maxTypeOfProduct || 1,
                maxInvestProfileValue: maxTypeOfProduct || 1,
                isFetchingInvestProfile: false,
                isFetchedInvestProfile: true,
                newProfile: selectedPortfolio,
                simulationId: id,
                errorFlags:
                    initialContribution < MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT && initialContribution > 0,
                recurringAmountError:
                    hasRecurringTransfer && recurringTransfer.amount < 1 && recurringTransfer.amount > 0,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SELECT_STRATEGY:
            return state.merge({
                investProfileValue: action.payload.value,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SHOW_DETAILS:
            return state.merge({
                showDetails: true,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_INITIAL_CONTRIBUTION_AMOUNT:
            const errorFlag =
                action.payload.amount < MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT && action.payload.amount > 0;

            return state.merge({
                initialContributionAmount: action.payload.amount,
                errorFlags: errorFlag,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_HAS_RECURRING_CONTRIBUTION:
            return state.merge({
                hasRecurringContribution: action.payload.hasRecurringContribution,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_CONTRIBUTION_DAY:
            return state.merge({
                recurringContributionDay: action.payload.day,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_PERIODICITY:
            return state.merge({
                periodicity: action.payload.periodicity,
            });
        case actionTypes.RA_MANAGEMENT_PLAN_SET_RECURRING_CONTRIBUTION_AMOUNT:
            const amount = action.payload.amount;
            const errorFlags =
                action.payload.amount !== '' ? amount > 0 && amount < MINIMUM_PERIODIC_CONTRIBUTION : false;

            return state.merge({
                recurringAmountError: errorFlags,
                recurringContributionAmount: action.payload.amount,
            });
        default:
            return state;
    }
};

module.exports = RAManagementPlan;
